import { render, staticRenderFns } from "./OrdersCrumb.vue?vue&type=template&id=018bd529&"
import script from "./OrdersCrumb.vue?vue&type=script&lang=ts&"
export * from "./OrdersCrumb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports